/**
 * CONFILEX × Joakim Sorola — Collection institutionnelle
 *
 * Manifest des œuvres mises en valeur dans l'expérience CONFILEX.
 * Présentation à la manière d'un cartel muséal : titre, technique, source,
 * mention de l'artiste, et ton institutionnel sobre.
 */

export const ART_COLLECTION = [
  {
    id: "ete-1",
    file: "/art/sorola/ete-1.jpg",
    title: "Figure au bord de mer, été",
    technique: "Huile sur toile",
    palette: ["#0B3A2A", "#7FB6A8", "#E6CFA8", "#F3E0CB"],
    accent: "marine",
    note: "Une silhouette en blanc, l'écume, la lumière du Sud — la concentration et la sérénité du large.",
  },
  {
    id: "ete-2",
    file: "/art/sorola/ete-2.jpg",
    title: "Femmes au cap rocheux",
    technique: "Huile sur toile",
    palette: ["#C9854F", "#1F4E7A", "#E6CFA8", "#8B3A3A"],
    accent: "ambre",
    note: "Pierre, sel et drapé — un paysage méditerranéen où la matière devient musique.",
  },
  {
    id: "promenade-1",
    file: "/art/sorola/promenade-1.jpg",
    title: "Promenade à deux, ressac",
    technique: "Huile sur toile",
    palette: ["#0B3A2A", "#9DB5D6", "#F1ECE3", "#C9A961"],
    accent: "azur",
    note: "Une marche silencieuse — la lumière sur le tissu, l'ombre sur le sable, la durée intacte.",
  },
  {
    id: "promenade-2",
    file: "/art/sorola/promenade-2.jpg",
    title: "Vers le rivage, après-midi",
    technique: "Huile sur toile",
    palette: ["#0B3A2A", "#A8B8C8", "#D8C9B0", "#8C9CA8"],
    accent: "platine",
    note: "L'élégance du mouvement — silhouettes parallèles, mer continue, certitude tranquille.",
  },
];

export const ARTIST = {
  name: "Joakim Sorola",
  bio: "Peintre attaché à la lumière du Sud, Joakim Sorola explore la matière, le textile et la mer dans une langue picturale à la fois classique et résolument contemporaine. Ses compositions, organisées autour de figures sobres et de gammes chromatiques chaudes, dialoguent avec la tradition du paysage méditerranéen.",
  curator_note:
    "CONFILEX présente une sélection d'œuvres en partenariat avec l'artiste, dans une logique de mécénat culturel discret. Aucune œuvre n'est commercialisée par la plateforme.",
};

export function getArt(id) {
  return ART_COLLECTION.find((a) => a.id === id) || ART_COLLECTION[0];
}
